<!--eslint-disable-->
<template>
  <div class="padd30">
    <h2 class="f18 fb normal gray_2">货品管理</h2>
    <div class="box20"></div>
    <div class="classify_list">
      <ul class="clear">
        <li class="active_classify">全部</li>
        <li>出售中</li>
        <li>已下架</li>
      </ul>
    </div>
    <div class="flex_space_between pad20_tb">
      <div>
        <el-input v-model="good_search" placeholder="请输入内容"></el-input>
        <el-button type="primary">搜索</el-button>
        <el-button>重置</el-button>
      </div>
      <div>
        <el-button>导出</el-button>
        <el-button type="primary">添加货品</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      class="t_center"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column
        label="商品名称">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column
        label="商品图">
        <template slot-scope="scope">
          <img :src="scope.row.picUrl" alt="">
        </template>
      </el-table-column>
      <el-table-column
        prop="unit"
        label="计量单位">
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格">
      </el-table-column>
      <el-table-column
        prop="sellUnit"
        label="销售单位">
      </el-table-column>
      <el-table-column
        prop="conversion"
        label="换算比例">
      </el-table-column>
      <el-table-column
        prop="classify"
        label="分类">
      </el-table-column>
      <el-table-column
        prop="inventory"
        label="库存">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.status === 1">审核中</el-tag>
          <el-tag type="warning" v-if="scope.row.status === 2">已审核</el-tag>
          <el-tag type="success" v-if="scope.row.status === 3">出售中</el-tag>
          <el-tag type="info" v-if="scope.row.status === 4">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        width="130"
        label="操作">
        <template>
          <span class="c_blue cursor">删除</span>
          <span class="pad10_l c_blue cursor">编辑</span>
          <span class="pad10_l c_blue cursor">上架</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="box20"></div>
    <div class="t_right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="40">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      good_search: "",
      currentPage: 1,
      tableData: [
        {
          name: "商品名称",
          picUrl: "https://files.t.nxin.com/qlw/yuantu/2020/8/21/c0/392afd3c-e9f4-421b-8bcf-bbfb215e2aff.jpg?imageView2/1/w/70/h/70",
          unit: "个",
          price: "100.5685",
          sellUnit: "个",
          conversion: "1",
          classify: "默认分类",
          inventory: "300",
          status: 1,
        },
        {
          name: "商品名称",
          picUrl: "https://files.t.nxin.com/qlw/yuantu/2020/8/21/c0/392afd3c-e9f4-421b-8bcf-bbfb215e2aff.jpg?imageView2/1/w/70/h/70",
          unit: "个",
          price: "100.5685",
          sellUnit: "个",
          conversion: "1",
          classify: "默认分类",
          inventory: "300",
          status: 2,
        },
        {
          name: "商品名称",
          picUrl: "https://files.t.nxin.com/qlw/yuantu/2020/8/21/c0/392afd3c-e9f4-421b-8bcf-bbfb215e2aff.jpg?imageView2/1/w/70/h/70",
          unit: "个",
          price: "100.5685",
          sellUnit: "个",
          conversion: "1",
          classify: "默认分类",
          inventory: "300",
          status: 3,
        },
        {
          name: "商品名称",
          picUrl: "https://files.t.nxin.com/qlw/yuantu/2020/8/21/c0/392afd3c-e9f4-421b-8bcf-bbfb215e2aff.jpg?imageView2/1/w/70/h/70",
          unit: "个",
          price: "100.5685",
          sellUnit: "个",
          conversion: "1",
          classify: "默认分类",
          inventory: "300",
          status: 4,
        },
      ],
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {},
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
